import { trigger, state, style, transition, animate, query, animateChild, group } from "@angular/animations"

export const labelAnimation = trigger('labelAnimation', [
  state('displayLabel', style({ top: '15px', opacity: 1 })),
  state('hideLabel', style({ top: '40px', opacity: 0 })),
  transition('displayLabel <=> hideLabel', animate('150ms linear'))
])

export const componentContainerAnimation = trigger('componentContainerAnimation', [
  state('displayLabel', style({ 'padding-top': '17px' })),
  state('hideLabel', style({ 'padding-top': 0 })),
  transition('displayLabel <=> hideLabel', group([
    query('@*', animateChild()),
    animate('300ms ease')
  ]))
])

export const tickAnimation = trigger('tickAnimation', [
  state('displayTick', style({ width: '20px', 'padding-right': '7px' })),
  state('hideTick', style({ width: 0, 'padding-right': 0 })),
  transition('displayTick <=> hideTick', animate('300ms ease'))
])

export const coverAnimation = trigger('coverAnimation', [
  state('void', style({ opacity: 0 })),
  state('*', style({ opacity: 1 })),
  transition('void <=> *', group([
    query('@*', animateChild()),
    animate('200ms cubic-bezier(.645, .045, .355, 1)'),
  ]))
])

export const modalAnimation = trigger('modalAnimation', [
  transition(':enter', [
    style({ transform: 'scale(1.35)' }),
    animate('200ms cubic-bezier(.645, .045, .355, 1)')
  ]),
  transition(':leave', animate('200ms cubic-bezier(.645, .045, .355, 1)', style({ transform: 'scale(.65)' })))
])